export default __webpack_public_path__ + "static/media/web.401eec58.png";